import { combineReducers } from "redux";
import userReducers from "./userReducers";

const rootReducer = combineReducers({
    userReducers
})

export default rootReducer